/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZohoServiceDeskSite {
    getFixupPrototypeFunction() { return ZohoServiceDeskSite.fixupPrototype; }

    static newInstance(model: Partial<ZohoServiceDeskSite>): ZohoServiceDeskSite {
        let obj = Object.assign(new ZohoServiceDeskSite(), model);
        ZohoServiceDeskSite.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZohoServiceDeskSite>): ZohoServiceDeskSite {
        if (!model) return null;
        return ZohoServiceDeskSite.newInstance(<ZohoServiceDeskSite> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZohoServiceDeskSite) {
        if (!obj) return;

        models.ZohoServiceDeskSite.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZohoServiceDeskSite): boolean {
        Object.setPrototypeOf(obj, ZohoServiceDeskSite.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Key for ZOHO ServiceDesk Site
     */
    key: string;

    /**
     * Name for ZOHO ServiceDesk Site
     */
    name: string;

}
